import { render, staticRenderFns } from "./formProposta_p3.vue?vue&type=template&id=748691c3&scoped=true"
import script from "./formProposta_p3.vue?vue&type=script&lang=js"
export * from "./formProposta_p3.vue?vue&type=script&lang=js"
import style0 from "./formProposta_p3.vue?vue&type=style&index=0&id=748691c3&prod&scoped=true&lang=scss"
import style1 from "./formProposta_p3.vue?vue&type=style&index=1&id=748691c3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748691c3",
  null
  
)

export default component.exports